<div role="group" [formGroup]="parts" class="time-range-input-container" (focusin)="onFocusIn($event)"
  (focusout)="onFocusOut($event)">

  <mtx-datetimepicker-toggle class="mtx-datetimepicker-toggle-prefix"
    [for]="datetimePickerFrom"></mtx-datetimepicker-toggle>
  <mtx-datetimepicker #datetimePickerFrom [type]="'time'" [mode]="'portrait'" [multiYearSelector]="false"
    [startView]="'clock'" [xPosition]="'start'" [twelvehour]="format12" [panelClass]="'time-picker'" [timeInput]="true"></mtx-datetimepicker>

  <input class="time-range-input-element" #timeFrom formControlName="from" (input)="onValueChange()"
    (timeChange)="onValueChange()" (dateChange)="onDateChange()" placeholder="{{'common.from' | translate}}"
    maxLength="8" matInput [mtxDatetimepicker]="datetimePickerFrom">

  <span class="time-range-input-spacer ">&ndash;</span>

  <input class="time-range-input-element" #timeTo formControlName="to" (input)="onValueChange()"
    (timeChange)="onValueChange()" (dateChange)="onValueChange()" placeholder="{{'common.to' | translate}}"
    maxLength="8" matInput [mtxDatetimepicker]="datetimePickerTo" (keyup.backspace)="autoFocusFrom(parts.controls.to)">

  <mtx-datetimepicker #datetimePickerTo [type]="'time'" [mode]="'portrait'" [multiYearSelector]="false"
    [startView]="'clock'" [xPosition]="'end'" [twelvehour]="format12" [panelClass]="'time-picker'" [timeInput]="true"></mtx-datetimepicker>
  <mtx-datetimepicker-toggle class="mtx-datetimepicker-toggle-suffix"
    [for]="datetimePickerTo"></mtx-datetimepicker-toggle>
</div>